import {Box, Grid, Image, Text} from "@mantine/core";
import ProductPlaceholderImage from '../../../../../assets/images/product_placeholder.png';
import {decode} from "html-entities";


const _RecentlyViewed = ({component}) => {
    return (
        <Box
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            bg={component?.customize_styles?.general_decoration?.background_color}
            style={{
                boxShadow: `#00000014 ${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}

        >
            <Text
                fz="18px"
                c={component?.customize_styles?.text_decoration?.color}
                mx={component?.customize_styles?.text_decoration?.margin_x}
                my={component?.customize_styles?.text_decoration?.margin_y}
                px={component?.customize_styles?.text_decoration?.padding_x}
                py={component?.customize_styles?.text_decoration?.padding_y}
                bg={component?.customize_styles?.text_decoration?.background_color}
                lh='1'
                fw={700}
            >
                {component?.customize_properties?.label}
            </Text>
            <Grid mt={12}>

                {
                    component?.items?.map((item, index) => (
                        <Grid.Col span={6}>
                            <Box
                                key={index}
                                pos="relative"
                                mx={component?.customize_styles?.box_decoration?.margin_x}
                                my={component?.customize_styles?.box_decoration?.margin_y}
                                px={component?.customize_styles?.box_decoration?.padding_x}
                                py={component?.customize_styles?.box_decoration?.padding_y}
                                bg={component?.customize_styles?.box_decoration?.background_color}
                                style={{
                                    boxShadow: `#00000014 ${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px`,
                                    borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                                    border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                                }}
                            >
                                <Image
                                    // h='120'
                                    fit="contain"
                                    src={item.image_url}
                                    fallbackSrc={ProductPlaceholderImage}
                                    // bg={component?.customize_styles?.image_decoration?.color}
                                    style={{ borderRadius: `${component?.customize_styles?.image_decoration?.radius}px` }}
                                />

                                <Text
                                    c={component?.customize_styles?.name_text_decoration?.color}
                                    fw={component?.customize_styles?.name_text_decoration?.font_weight}
                                    fz={component?.customize_styles?.name_text_decoration?.font_size}
                                    fs={component?.customize_styles?.name_text_decoration?.font_style}
                                    ta="center"
                                    mt={12}
                                    lh="18px"
                                    lineClamp={1}
                                    translate="yes"
                                >
                                    {item?.name}
                                </Text>
                                <Text
                                    c={component?.customize_styles?.product_price_text_decoration?.color}
                                    bg={component?.customize_styles?.product_price_text_decoration?.background_color}
                                    fw={component?.customize_styles?.product_price_text_decoration?.font_weight}
                                    fz={component?.customize_styles?.product_price_text_decoration?.font_size}
                                    lh={1}
                                    ta="center"
                                >
                                    {decode(item?.currency)} {item?.discount_price ? item.discount_price : item?.price}
                                </Text>
                            </Box>
                        </Grid.Col>
                    ))
                }
            </Grid>
        </Box>
    )
}
export default _RecentlyViewed;